import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createBanner } from "../../../api/banner.api";
import ErrorResponse from "../../../components/ErrorResponse";
import Editor from "../../../components/homepage/top-banner/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const TopBannerCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/homepage/top-banner');
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createBanner(data));
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.topBanner.title3')}
      />

      <Editor
        submit={submit}
      />
    </div>
  );
}

export default TopBannerCreate;